<div class="o100w-moneybar-legend">
  <div class="o100w-moneybar-legend-item">
    <mat-icon
      class="o100w-moneybar-legend-color--received o100w-moneybar-legend-color"
      svgIcon="crop-square"
    ></mat-icon>
    <span class="o100w-moneybar-legend-label">received&nbsp;payments</span>
  </div>
  <div class="o100w-moneybar-legend-item">
    <mat-icon
      class="o100w-moneybar-legend-color--future-payments o100w-moneybar-legend-color"
      svgIcon="crop-square"
    ></mat-icon>
    <span class="o100w-moneybar-legend-label">present&nbsp;value&nbsp;of&nbsp;future&nbsp;payments</span>
  </div>
  <div class="o100w-moneybar-legend-item">
    <mat-icon
      class="o100w-moneybar-legend-color--to-be-funded o100w-moneybar-legend-color"
      svgIcon="crop-square"
    ></mat-icon>
    <span class="o100w-moneybar-legend-label">still&nbsp;to&nbsp;be&nbsp;funded</span>
  </div>
  <div class="o100w-moneybar-legend-item">
    <mat-icon class="o100w-moneybar-legend-color--buffer o100w-moneybar-legend-color" svgIcon="crop-square"></mat-icon>
    <span class="o100w-moneybar-legend-label">risk&nbsp;buffer</span>
  </div>
</div>
